const serviceContent = {
    brandIdentity: {
        title: "Brand Identity",
        intro: "Crafting memorable identities that stand out across every digital and customer-facing touchpoint.",
        summary: "WiseCursor develops brand systems that make teams easier to recognize, trust, and remember.",
        image: "Services__card1.png",
        path: "/services/brand-identity",
        points: [
            {
                title: "Visual Foundation",
                body: "Logo direction, color, typography, and design language built for consistent execution.",
            },
            {
                title: "Brand Expression",
                body: "A practical identity system that can extend into web, campaigns, social, and product surfaces.",
            },
            {
                title: "Launch Ready",
                body: "Organized assets and guidance so the brand can be used cleanly after the design phase.",
            },
        ],
        bestFor: [
            "Growing teams rebranding after expansion, a market shift, or a new launch.",
            "Companies whose website, marketing, and product visuals no longer feel like one system.",
            "Product-led organizations bringing a consistent brand language into their digital experience.",
        ],
    },
    uiuxDesign: {
        title: "UI/UX Design",
        intro: "Designing seamless user experiences that help people understand, decide, and act with confidence.",
        summary: "We turn product ideas into flows and screens that balance user needs with business priorities.",
        image: "Services__card2.png",
        path: "/services/ui-ux-design",
        points: [
            {
                title: "User Flows",
                body: "Map the main tasks, decision points, and friction risks before polishing the interface.",
            },
            {
                title: "Interface Design",
                body: "Create responsive screen patterns with hierarchy, spacing, and interactions that feel intentional.",
            },
            {
                title: "Design Handoff",
                body: "Prepare clear assets and structure so implementation can move without avoidable guesswork.",
            },
        ],
        bestFor: [
            "Product teams clarifying a key customer task, workflow, or conversion path.",
            "Companies improving a complex website or product experience with visible friction.",
            "Stakeholders who need a shared prototype before committing to development.",
        ],
    },
    development: {
        title: "Web App Development",
        intro: "Building cutting-edge digital solutions that are responsive, practical, and ready to evolve.",
        summary: "WiseCursor supports implementation from page structure through interactive product experiences.",
        image: "Services__card3.png",
        path: "/services/web-app-development",
        points: [
            {
                title: "Responsive Builds",
                body: "Create web pages and app surfaces that adapt cleanly across desktop, tablet, and mobile.",
            },
            {
                title: "Component Structure",
                body: "Translate design patterns into reusable code that keeps future updates manageable.",
            },
            {
                title: "Launch Support",
                body: "Help prepare the product for release with practical checks, polish, and iteration support.",
            },
        ],
        bestFor: [
            "Teams with validated designs that are ready for a responsive website or product build.",
            "Businesses that need a consistent experience across desktop, tablet, and mobile.",
            "Organizations that want maintainable code instead of a one-time launch artifact.",
        ],
    },
    animation: {
        title: "Animation",
        intro: "Bringing your vision to life with motion that supports storytelling, clarity, and engagement.",
        summary: "Motion can make a brand feel more memorable when it is purposeful and tied to product moments.",
        image: "Services__card4.png",
        path: "/services/animation",
        points: [
            {
                title: "Motion Direction",
                body: "Define how transitions, reveals, and animated moments should support the user experience.",
            },
            {
                title: "Visual Storytelling",
                body: "Create motion concepts for launches, explainers, social moments, and product communication.",
            },
            {
                title: "Interaction Polish",
                body: "Use animation to guide attention without making the interface feel heavy or distracting.",
            },
        ],
        bestFor: [
            "Teams explaining a complex product, service, or process to a new audience.",
            "Brands preparing a launch, campaign, presentation, or product moment.",
            "Digital products that need feedback and transitions to make the next step clearer.",
        ],
    },
    uxStrategy: {
        title: "UX Strategy",
        intro: "Strategizing user-centric designs for success before visual design or development begins.",
        summary: "UX strategy creates the blueprint for decisions that make products clearer and more effective.",
        image: "Services__card5.png",
        path: "/services/ux-strategy",
        points: [
            {
                title: "Research Direction",
                body: "Clarify audience needs, goals, and constraints so product decisions have a stronger base.",
            },
            {
                title: "Experience Planning",
                body: "Shape journeys, content structure, and priority actions before the interface is finalized.",
            },
            {
                title: "Optimization",
                body: "Identify where the product can improve conversion, comprehension, and task completion.",
            },
        ],
        bestFor: [
            "Leaders deciding where to invest before moving into design or development.",
            "Teams with customer signals but no shared experience roadmap.",
            "Product and marketing partners who need to align user needs with business priorities.",
        ],
    },
    aiBusiness: {
        title: "Practical & Governed AI",
        intro: "Designing AI-assisted workflows that accelerate useful work while keeping people informed, accountable, and in control.",
        summary: "WiseCursor helps teams identify practical opportunities for specialist AI support, then turn them into clear, human-approved workflows.",
        image: "Services__card6.png",
        path: "/services/ai-business",
        points: [
            {
                title: "Opportunity & Scope Mapping",
                body: "Identify the task, intended value, available evidence, data boundaries, and owner before introducing AI into a workflow.",
            },
            {
                title: "Specialist Workflow Design",
                body: "Coordinate focused research, brand, UX, content, build, or QA workstreams around the people and systems that need to use them.",
            },
            {
                title: "Human-Approved Implementation Path",
                body: "Turn a high-value idea into reviewable drafts, approval points, and focused next steps that can be tested and refined responsibly.",
            },
        ],
        bestFor: [
            "Teams with repetitive or knowledge-heavy work that may benefit from AI support.",
            "Leaders who need human approval, clear owners, and visible boundaries around AI work.",
            "Organizations testing a practical AI workflow before expanding it across the business.",
        ],
    },
};

export default serviceContent;
